import React from "react";
import "./home.css";
import MainHeader from "../../components/MainHeader";
import Programs from "../../components/programs";
import Values from "../../components/Values";
import FAQs from "../../components/FAQs";
import Temoignages from "../../components/Temoignages";
const Home = () => {
    return (
        <>
            <MainHeader />
            <Programs />
            <Values />
            <FAQs/>
            <Temoignages/>
        </>
    );
};

export default Home;
